var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToggleOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 6h-11C3.464 6 1 8.688 1 12s2.464 6 5.5 6h11c3.036 0 5.5-2.688 5.5-6s-2.464-6-5.5-6Zm0 9.6c-1.826 0-3.3-1.608-3.3-3.6s1.474-3.6 3.3-3.6c1.826 0 3.3 1.608 3.3 3.6s-1.474 3.6-3.3 3.6Z"
})));
export default SvgToggleOn;